import React, { Component } from 'react';
import { Autocomplete, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { withNamespaces } from 'react-i18next';
import Axios from 'axios';
import Fade from "react-reveal/Fade";
import { TextArea } from "semantic-ui-react";
import { Services } from '../../Services';
import Checkbox from '@mui/material/Checkbox';
import $ from "jquery"
import CustomPopupIcon from '../../add/customPopupIcon';
// const rest = new restService();

const useStyles = (theme) => ({
    textfield: {
        "& .MuiInputBase-input.MuiAutocomplete-input": {
            fontSize: 12,
            color: "#000a2e"
        }
    },
    datefield: {
        "& .MuiInput-input.MuiInputBase-input": {
            fontSize: 12,
            color: "#000a2e"
        }
    },
    searchLabel: {
        fontSize: 12,
    },
    popupIndicator: {
        "& path": {
            d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
        },
    },
    popupIndicatorOpen: {
        "& path": {
            d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
        },
    },
});

class Consignatario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            consignees: this.props.consignees,
            customerSelected: "",
            consigneesArray: [],
            consigneeSelected: null,
            direccionConsignatario: "",
            contactSelected: null,
            contactsArray: [],
            consigneeInfo: {},
            contactInfo: {},
            contactInfoVisual: {},
            contacts: [],
            found: null,
            foundContact: null,
            isLoaded: false,
            firstContact: true,
            errors: {},
            info: this.props.info ? this.props.info : {},
            isEdit: this.props.isEdit ? this.props.isEdit : false,
            checkedAddress: false
        };
    }


    componentDidMount = () => {
        let { isLoaded, info, consigneeSelected, contactSelected, direccionConsignatario, checkedAddress, consignees } = this.state;
        if (!isLoaded) {
            let checked = !info.CheckDeliveryAddress || info.CheckDeliveryAddress == 0 ? false : true;
            this.setState({

                consigneeSelected: info && info.ConsigneeId ? {
                    value: info.ConsigneeCode, label: info.ConsigneeName,
                    subLabel: info.Address
                } : consigneeSelected,
                contactSelected: info && info.ConsigneeContacId ? { value: info.ConsigneeContacId, label: info.ConsigneeContact } : contactSelected,

                checkedAddress: info && info.CheckDeliveryAddress ? checked : checkedAddress,
                direccionConsignatario: info && info.DeliveryAddress ? info.DeliveryAddress : direccionConsignatario,
                errors: this.props.errors,
                customerSelected: info && info.CustomerId ? info.CustomerId : ""
            });
        }
        if (info && info.ConsigneeId) {
            if (info.ConsigneeContacId) {
                this.getContactsLabel();
            }

            if (consignees && consignees.length > 0) {
                this.buildArrayConsignees();
            }
            this.validateComponentHeight();
        }
    }

    componentWillReceiveProps = (nextProps) => {

        let { customerSelected, isLoaded, info, consigneeSelected, contactSelected,
            direccionConsignatario, checkedAddress, consigneeInfo, contactInfo, contactsArray } = this.state;
        let infoNext = nextProps.info;
        if (!isLoaded) {
            this.setState({
                errors: nextProps.errors,
                info
            });
        }
        let resetFlag = false;
        if (nextProps.CustomerId != customerSelected) {
            resetFlag = true;
            customerSelected = nextProps.CustomerId;
        }

        if (nextProps.isEdit) {
            let checked = !infoNext || !infoNext.CheckDeliveryAddress || infoNext.CheckDeliveryAddress == 0 ? false : true;
            this.setState({
                isEdit: nextProps.isEdit,
                consigneeSelected: resetFlag ? null : consigneeSelected,
                contactSelected: resetFlag ? null : contactSelected,
                contactInfo: resetFlag ? {} : contactInfo,
                consigneeInfo: resetFlag ? {} : consigneeInfo,
                contactsArray: resetFlag ? [] : contactsArray,
                customerSelected,
                consignees: nextProps.consignees,
                checkedAddress: resetFlag ? false : infoNext && infoNext.CheckDeliveryAddress ? checked : checkedAddress,
                direccionConsignatario: resetFlag ? "" : infoNext && infoNext.DeliveryAddress ? infoNext.DeliveryAddress : direccionConsignatario,
                errors: this.props.errors
            }, () => {
                if (this.state.info.ConsigneeContacId) {
                    this.getContactsLabel();
                }
                this.buildArrayConsignees();
                this.validateComponentHeight();
            });
        }

    }


    buildArrayConsignees = () => {
        const { consignees } = this.state;

        let array = [];
        consignees.forEach((e) => array.push({ value: e.entityCode, label: e.entityName, subLabel: e.address }));
        this.setState({ consigneesArray: array }, () => this.setFirstOrderValues());
    }

    setFirstOrderValues = () => {
        let { consigneeSelected, consigneesArray, found } = this.state;
        if (consigneeSelected && consigneeSelected.value != "" && !found) {
            let found = consigneesArray.find((element) => element.value === consigneeSelected.value);
            if (found) this.handleChangeSelect(null, consigneeSelected);
            this.setState({
                found
            });
        }
    }

    handleChangeSelect = (evt, data) => {
        let { consignees, consigneeInfo, info } = this.state;
        if (data) {
            consigneeInfo = consignees.find((sup) => { return sup.entityCode == data.value })
            consigneeInfo.Address = this.generateAddress(consigneeInfo);

            this.setState({
                consigneeSelected: data, selected: data.value,
                contactInfo: {},
                consigneeInfo,
                direccionConsignatario: this.state.checkedAddress ? consigneeInfo.Address : this.state.direccionConsignatario,
                contactSelected: null,
            },
                this.buildConsigneeDetail(data.value, consigneeInfo.Address))
        }
        else this.setState({
            consigneeSelected: null,
            contactsArray: [],
            contacts: [],
            contactSelected: null,
            contactInfo: {},
            consigneeInfo: {},
            direccionConsignatario: ""
        }, () => {
            this.props.sendProps({
                stateField: 'ConsigneeId',
                id: ''
            });
            this.props.sendProps({
                stateField: 'ConsigneeContacId',
                id: ''
            });
            this.props.sendProps({
                stateField: 'DeliveryAddress',
                id: ''
            });
        });
        this.validateComponentHeight();
    }

    generateAddress = (consignee) => {
        return consignee.address;
    }
    generateAddressEdit = () => {
        let { info } = this.state;
        return info.ConsigneeAddress;
    }


    validateComponentHeight = () => {
        let maxHeight = 0;
        $(".direccion-check").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".direccion-check").css("min-height", maxHeight);

        maxHeight = 0;
        $(".info-general-div").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".info-general-div").css("min-height", maxHeight);

        maxHeight = 0;
        $(".div-contacto").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".div-contacto").css("min-height", maxHeight);

        maxHeight = 0;
        $(".div-entidad").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".div-entidad").css("min-height", maxHeight);

        maxHeight = 0;
        $(".contact-name").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".contact-name").css("min-height", maxHeight);

        maxHeight = 0;
        $(".contact-phone").each((index, val) => {
            maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
        });
        $(".contact-phone").css("min-height", maxHeight);

    }


    buildConsigneeDetail = (id, address) => {
        const { consignees } = this.state;
        let index = consignees.findIndex(x => x.entityCode === id);
        this.setState({ consigneeSelected: consignees[index] }, () => {
            this.props.sendProps({ stateField: 'ConsigneeId', id: this.state.consigneeSelected.value })
            this.props.sendProps({ stateField: "DeliveryAddress", id: this.state.direccionConsignatario })
            this.props.sendProps({
                stateField: 'ConsigneeContacId',
                id: ''
            });
        });
        this.getContacts(consignees[index].entityCode);

    }


    getContacts = (id) => {
        let { contacts, consignees } = this.state;
        consignees.map((consignee) => {
            if (consignee.entityCode == id) {
                contacts = consignee.contacts == "" ? [] : consignee.contacts;
            }
        })
        this.setState({
            contacts
        }, () => {
            this.buildArrayContacts()
        });
    }
    getContactsLabel = () => {
        let { info } = this.state;

        Axios.get(`${Services.ORDEN_SERV.path}orden/contactInfo/${info.ConsigneeContacId}`).then((data) => {
            let contact = data.data.data;
            this.setState({
                contactInfoVisual: contact ? contact : {}
            }, () => {

                this.validateComponentHeight();
            });
        }).catch((error) => {
            console.error(error);
        });


    }

    buildArrayContacts = () => {
        const { contacts } = this.state;
        let array = [];
        contacts.forEach((e) => array.push({ value: e.contactCode, label: e.name }));
        this.setState({ contactsArray: array }, () => this.setFirstOrderValuesContacts());

    }


    setFirstOrderValuesContacts = () => {
        let { contactSelected, info, firstContact } = this.state;
        if (info && info.ConsigneeCodeEPContact && info.ConsigneeCodeEPContact != "" && firstContact) {
            contactSelected = { value: info.ConsigneeCodeEPContact, label: info.ConsigneeContact }
            this.setState({ contactSelected, firstContact: false }, () => {
                this.handleChangeSelectContact(null, contactSelected);
            })
        }




    }


    handleChangeSelectContact = (evt, data) => {
        let { contactInfo, contacts } = this.state;
        if (data) {
            contactInfo = contacts.find((cont) => { return cont.contactCode == data.value })

            this.setState({ contactInfo, contactSelected: data }, () => {
                this.props.sendProps({ stateField: 'ConsigneeContacId', id: data.value });
            });
        }
        else this.setState({ contactSelected: null, contactInfo: {} }, () => {
            this.props.sendProps({ stateField: 'ConsigneeContacId', id: '' });
        });
        this.validateComponentHeight();
    }

    handleChange = (name, isEdit) => (event) => {
        let { direccionConsignatario } = this.state;
        direccionConsignatario = event.target.value;
        this.setState({ direccionConsignatario }, this.props.sendProps({ stateField: name, id: direccionConsignatario }));
    };

    handleChangeCheck = (event) => {
        let { consigneeInfo, direccionConsignatario } = this.state;
        let checked = event.target.checked
        let address = event.target.checked ? consigneeInfo.Address : "";
        direccionConsignatario = address;
        this.setState({ checkedAddress: checked, direccionConsignatario },
            () => {
                this.props.sendProps({ stateField: "CheckDeliveryAddress", id: checked });
                this.props.sendProps({ stateField: "DeliveryAddress", id: direccionConsignatario })
            });
    }
    render() {
        const { consigneesArray, consigneeInfo, contactInfo, consigneeSelected, contactsArray, contactSelected, direccionConsignatario } = this.state;

        const { classes } = this.props;
        return (
            <div>
                {this.state.isEdit ? <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-md-12">
                        <span className='bold-euro' >
                            {this.props.t("select_consignee_info")}</span>
                    </div>
                </div> : ""}
                <div className="row div-entidad" style={{ marginBottom: "20px" }} >
                    {this.state.isEdit ?
                        <div className="col-md-12">
                            <span className='bold-euro' >
                                {this.props.t("consignee")}</span>
                            <span style={{ color: "#ff0000" }}>*</span>
                            <Autocomplete
                                id="ConsigneeCode"
                                name="select-contact"
                                className='input-euro'
                                size="small"
                                ListboxProps={{
                                    sx: { fontSize: 12 },
                                }}
                                sx={{
                                    '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                                        fontSize: 12,
                                    },
                                }}
                                // classes={{
                                //     clearIndicatorDirty: classes.clearIndicator,
                                //     popupIndicator: classes.popupIndicator,
                                //     popupIndicatorOpen: classes.popupIndicatorOpen,
                                // }}
                                popupIcon={<CustomPopupIcon /> }
                                getOptionLabel={(option) => (option.label)}
                                renderOption={(props, option, value) => {
                                    props.key = option.key;
                                    return <div {...props}>
                                        {
                                            option.subLabel && option.subLabel != "" ?
                                                <div className="row">
                                                    <div className="col-12">{option.label}</div>


                                                    <div className="col-12">
                                                        <label style={{ opacity: ".5" }}>{option.subLabel}</label> </div>


                                                </div>
                                                :
                                                <span>{option.label}</span>
                                        }
                                    </div>
                                }
                                }
                                filterOptions={(options, event) => {
                                    let filteredOptions = options.filter((opt) => {
                                        return event.inputValue == "" ||
                                            opt.label.toLowerCase().includes(event.inputValue.toLowerCase())
                                    })
                                    return filteredOptions;
                                }}
                                // freeSolo
                                options={consigneesArray ? consigneesArray : []}



                                onChange={this.handleChangeSelect}
                                value={consigneeSelected}
                                renderInput={(params) => {
                                    params.inputProps.value = consigneeSelected && consigneeSelected.label ?
                                        consigneeSelected.label : params.inputProps.value;

                                    return <TextField
                                        {...params}
                                        variant="standard"

                                    />
                                }}
                            />

                        </div> :
                        <div className="col-md-12">
                            <div style={{ marginBottom: "5px" }}>
                                <span className='bold-euro'>
                                    {this.props.t("consignee")}</span>
                            </div>
                            <div>
                                <span className='label-euro'>{this.state.info.ConsigneeName}</span>
                            </div>
                        </div>}


                </div>
                <div className="row div-contacto" style={{ marginBottom: "20px" }} >
                    {this.state.isEdit ?
                        <div className="col-md-12">
                            <span className='bold-euro'>
                                {this.props.t("contact")}</span>

                            <Autocomplete
                                closeText={false}
                                openText={false}
                                id="ConsigneeContacId"
                                name="select-contact"
                                size="small"
                                className='input-euro'
                                // freeSolo
                                options={contactsArray ? contactsArray : []}
                                getOptionLabel={(option) => option.label}
                                onChange={this.handleChangeSelectContact}

                                value={contactSelected}
                                ListboxProps={{
                                    sx: { fontSize: 12 },
                                }}
                                sx={{
                                    '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                                        fontSize: 12,
                                    },
                                }}
                                renderInput={(params) => {

                                    return <TextField

                                        {...params}
                                        variant="standard"

                                    />
                                }}
                            />

                        </div> :
                        <div className="col-md-12">
                            <div style={{ marginBottom: "5px" }}>
                                <span className='bold-euro'>
                                    {this.props.t("contact")}</span>
                            </div>
                            <div>
                                <span className='label-euro'>{this.state.info.ConsigneeContact}</span>
                            </div>
                        </div>}

                </div>
                <div className='row'>
                    {/* <div className='info-general-div' style={{ display: "flex", alignItems: "center", width: "100%" }}> */}



                    {/* <div className="col-md-2"> */}
                    <div className="col-xs-2 col-md-2 col-lg-2 d-flex align-items-center d-flex justify-content-center">
                        {/* <em style={{ fontSize: "25px", marginLeft: "35%" }} className="fas fa-user mr-2"></em> */}
                        <span className="icon-organizations icons-front-module"></span>
                    </div>
                    <div className="col-xs-10 col-md-10 col-lg-10">

                        {/* <div className="col-md-10"> */}
                        <div style={{ marginBottom: "5px" }}>

                            <span className='label-euro'><b>{this.state.isEdit ? consigneeInfo.entityName :
                                this.state.info.ConsigneeName} </b></span>
                        </div>

                        <div style={{ marginBottom: "5px" }}>

                            <span className='label-euro'>{this.state.isEdit ? consigneeInfo.Address :
                                this.generateAddressEdit(this.state.info)} </span>
                        </div>

                        <div className='contact-name' style={{ marginBottom: "5px" }}>
                            <span className='label-euro'>{this.state.isEdit ? contactInfo ? contactInfo.name : "" :
                                this.state.contactInfoVisual.Name}</span>
                        </div>

                        <div className='contact-phone' style={{ marginBottom: "5px" }}>
                            <span className='label-euro'>{this.state.isEdit ? contactInfo ? contactInfo.telephone : "" :
                                this.state.contactInfoVisual.Telephone} </span>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
                <div className='row direccion-check'>
                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px", width: "100%" }}>



                        {(consigneeInfo && consigneeInfo.entityName) ||
                            (this.state.info && this.state.info.ConsigneeName) ? <div className="col-md-10">
                            <div className="d-flex align-items-center">

                                <span className='label-euro'>{this.props.t("same_pickup_address")}</span>
                                {this.state.isEdit ?
                                    <Checkbox
                                        style={{ marginLeft: "5px",color: "#000a2e" }}
                                        onChange={this.handleChangeCheck}
                                        color="primary"
                                        disabled={!this.state.isEdit}
                                        checked={this.state.checkedAddress}
                                        value={this.state.checkedAddress}

                                    /> :
                                    <span className='label-euro' style={{ marginLeft: "5px" }}>{this.state.checkedAddress ? this.props.t("yes") : "No"}</span>}
                            </div>

                        </div> : ""}

                    </div>
                </div>
                <div className='row'>

                    <div style={{ marginTop: "15px" }} className="col-md-12 col-12 col-lg-12 col-sm-12" key={"consignatarioDir"}>
                        <Fade left opposite>
                            {" "}
                            <span>
                                <label className='bold-euro'>
                                    {this.props.t("delivery_address")}
                                    {this.state.isEdit ?
                                        <span style={{ color: "#ff0000" }}>*</span> : false
                                    }
                                </label>
                            </span>
                        </Fade>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {!this.state.isEdit ?
                                <span className='label-euro'>{direccionConsignatario} </span> :
                                this.state.checkedAddress ?
                                    <span className='label-euro'>{direccionConsignatario} </span> : <TextArea
                                        required={false}
                                        className='custom-textarea'
                                        placeholder={this.props.t("address")}
                                        disabled={!this.state.isEdit}
                                        value={direccionConsignatario}
                                        style={{ width: "100%" }}
                                        onChange={this.handleChange("DeliveryAddress", false)}
                                    />
                            }
                        </div>

                    </div>
                </div>
            </div >
        );
    }
}

export default withNamespaces()(withStyles(useStyles)(Consignatario));